import * as constants from './helpwidget-constants';

export const openHelpWidget = () => (
  {
    type: constants.OPEN,
  }
);

export const closeHelpWidget = () => (
  {
    type: constants.CLOSE,
  }
);

export const setSupportDeskLoading = () => (
  {
    type: constants.SUPPORT_DESK_LOADING,
  }
);

export const setSupportDeskActive = () => (
  {
    type: constants.SUPPORT_DESK_ACTIVE,
  }
);

export const setNewFeaturesActive = () => (
  {
    type: constants.NEW_FEATURES_ACTIVE,
  }
);

export const receiveNewFeatures = (count) => (
  {
    type: constants.RECEIVE_NEW_FEATURES,
    payload: {
      count,
    },
  }
);

export const setLiveChatActive = () => (
  {
    type: constants.LIVE_CHAT_ACTIVE,
  }
);

export const setLiveChatDisabled = () => (
  {
    type: constants.LIVE_CHAT_INACTIVE,
  }
);



// WEBPACK FOOTER //
// ./src/app/stores/ui/components/helpwidget/helpwidget-actions.js